import WarningScreen from "./WarningScreen";
export default WarningScreen;